/**
 * 路径标准化和比较工具函数
 * 解决末尾斜杠、.html后缀等路径匹配问题
 */

/**
 * 标准化路径：移除末尾斜杠和.html后缀
 * @param path 原始路径
 * @returns 标准化后的路径
 */
export function normalizePath(path: string): string {
  if (!path) return path;

  // 移除 .html 后缀
  let normalized = path.replace(/\.html$/, "");

  // 移除末尾斜杠（除根路径外）
  if (normalized !== "/" && normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }

  return normalized;
}

/**
 * 比较两个路径是否相等（忽略末尾斜杠和.html后缀）
 * @param path1 路径1
 * @param path2 路径2
 * @returns 是否相等
 */
export function pathEquals(path1: string, path2: string): boolean {
  return normalizePath(path1) === normalizePath(path2);
}

/**
 * 检查路径是否在路径列表中（忽略末尾斜杠和.html后缀）
 * @param path 要检查的路径
 * @param pathList 路径列表
 * @returns 是否在列表中
 */
export function pathInList(path: string, pathList: string[]): boolean {
  const normalizedPath = normalizePath(path);
  return pathList.some(
    (listPath) => normalizePath(listPath) === normalizedPath,
  );
}

/**
 * 检查路径是否以指定前缀开始（忽略末尾斜杠和.html后缀）
 * @param path 要检查的路径
 * @param prefix 前缀
 * @returns 是否匹配
 */
export function pathStartsWith(path: string, prefix: string): boolean {
  const normalizedPath = normalizePath(path);
  const normalizedPrefix = normalizePath(prefix);
  return normalizedPath.startsWith(normalizedPrefix);
}
